import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import CategoryRefBlockData from 'Models/Content/CategoryRefBlockData';
import ContentCarouselItemBlockData from 'Models/Content/ContentCarouselItemBlockData';
import ContentsCarrouselBlockData from 'Models/Content/ContentsCarrouselBlockData';
import React, {useEffect, useState} from 'react';
import ContentCategories, {ContentCategory} from './ContentCategories';
import {SliderItem} from './ContentSlider';
import {getImageProps} from 'app/utilities/ImageProps';

const ContentsCarrouselBlock = ({data, context}: ComponentProps<ContentsCarrouselBlockData>) => {
  const [categories, setCategories] = useState<ContentCategory[]>([]);
  const [sliders, setSliders] = useState<SliderItem[]>([]);

  useEffect(() => {
    setCategories(data.relatedCategory.expandedValue.map((item: CategoryRefBlockData) => ({id: item.id.value, name: item.name.value})));
    setSliders(
      data.items.expandedValue.map((item: ContentCarouselItemBlockData) => ({
        relatedCategory: item.relatedCategory,
        name: item.title.value,
        image: getImageProps(item.image, context),
        description: item.description.value,
      })),
    );
  }, []);

  return (
    <div className='ContentsCarrouselBlock'>
      {categories.length > 0 && sliders.length > 0 && <ContentCategories categories={categories} sliders={sliders} />}

      {data.buttonLink?.value && data.buttonLinkTitle?.value && (
        <a className='ContentsCarrouselBlock__link' href={data.buttonLink.value}>
          {data.buttonLinkTitle.value}
        </a>
      )}
    </div>
  );
};

export default ContentsCarrouselBlock;
